export const getUserColumns = (translate) => {
  return [
    {
      dataField: 'photo',
      text: '',
      sort: false,
    },
    {
      dataField: 'name',
      text: translate('Name'),
      sort: true,
    },
    {
      dataField: 'email',
      text: translate('Email'),
      sort: true,
    },
    {
      dataField: 'account',
      text: translate('Account'),
      sort: true,
    },
    {
      dataField: 'type',
      text: translate('Type'),
      sort: true,
    },
    {
      dataField: 'status',
      text: translate('Status'),
      sort: true,
    },
    {
      dataField: 'action',
      text: translate('Action'),
      sort: false,
    },
  ];
};

export const getDeactivatedUserColumns = (translate) => {
  return [
    {
      dataField: 'name',
      text: translate('Name'),
      sort: true,
    },
    {
      dataField: 'email',
      text: translate('Email'),
      sort: true,
    },
    {
      dataField: 'account',
      text: translate('Account'),
      sort: true,
    },
    {
      dataField: 'status',
      text: translate('Status'),
      sort: true,
    },
    {
      dataField: 'action',
      text: translate('Action'),
      sort: true,
    },
  ];
};

export const getPendingUserColumns = (translate) => {
  return [
    {
      dataField: 'name',
      text: translate('Name'),
      sort: true,
    },
    {
      dataField: 'email',
      text: translate('Email'),
      sort: true,
    },
    {
      dataField: 'account',
      text: translate('Account'),
      sort: true,
    },
    {
      dataField: 'createdAt',
      text: translate('Register Date'),
      sort: true,
      headerStyle: () => ({
        width: '200px',
        maxWidth: '200px',
      }),
    },
    {
      dataField: 'action',
      text: translate('Action'),
      sort: true,
    },
  ];
};
